export default __webpack_public_path__ + "static/media/current_position.fbcd153c.svg";